import React from 'react';
import { Link } from 'react-router-dom';
import './css/Talk.css';
import s1 from '../assets/ss5.svg';
import s2 from '../assets/s2.svg';
import s3 from '../assets/ss4.svg';
import s4 from '../assets/s4.svg';
import AnimateInView from './AnimateInView';

const Talk = () => {
    const data = [
        {
            logo: s1,
            text: "Custom Furniture",
            description: "Get bespoke wooden furniture crafted to your exact specifications and style preferences."
        },
        {
            logo: s2,
            text: "Interior Woodwork",
            description: "Transform your space with custom cabinetry, wall paneling, and architectural wooden elements."
        },
        {
            logo: s3,
            text: "Design Consultation",
            description: "Collaborate with our master craftsmen to design the perfect wooden pieces for your space."
        },
        {
            logo: s4,
            text: "Restoration Services",
            description: "Restore and refinish your cherished wooden furniture to its original glory."
        },
    ]

    return (
        <section className='talk-main-div1'>
            <AnimateInView delay={0.2}>
                <div className='talk-main-div'>
                    <div className='talk-heading-div'>
                        <h1 className='talk-heading'>Connect With Us</h1>
                    </div>
                    <div className='talk-content-div1'>
                        <h2 className='talk-content-head'>Crafting Your Vision in Wood</h2>
                    </div>
                    <div className='talk-content-div2'>
                        <p className='talk-content-div2-para'>At Dhiman Wood Works, we bring decades of woodworking expertise to create stunning pieces that enhance your space. Let our master craftsmen bring your ideas to life.</p>
                    </div>
                    <div className='talk-content-div3'>
                        {data.map((item, index) => (
                            <Link to='/contact' key={index}>
                                <div className='talk-content-div3-map-content'>
                                    <div className='talk-content-div3-map-content-logo'>
                                        <img className='talk-logo-style' src={item.logo} alt={item.text} />
                                        <h2 className='map-talk-item-content'>{item.text}</h2>
                                    </div>
                                    <div className='talk-content-description'>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                    <div className='talk-content-div4'>
                        <p className='talk-content-div4-para'>Contact: +91 9814562530 , +91 7807462535</p>
                        <p className='talk-content-div4-para'>Email:dhimanwoodwork41@gmail.com</p>
                        <p className='talk-content-div4-para'>Workshop Address: HPA-R3-SCO-023, DLF HYDE PARK ESTATE, New Chandigarh, Mullanpur, Punjab-140901</p>
                    </div>
                </div>
            </AnimateInView>
        </section>
    )
}

export default Talk;
